if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';


        
        document.querySelectorAll(".variant-picker-card").forEach(function(card) {
    card.addEventListener("click", function() {
        // Retirer la sélection des autres variantes et appliquer la nouvelle sélection
        document.querySelectorAll(".variant-picker-card").forEach(c => c.classList.remove("selected"));
        this.classList.add("selected");

        // Récupérer l'ID de la variante sélectionnée
        let selectedVariantId = this.getAttribute("data-variant-id");
        console.log("selectedVariantId récupéré :", selectedVariantId); // Debug

        // Met à jour l'input caché de la variante
        let inputVariant = document.getElementById("variant-id");
        if (inputVariant) {
            inputVariant.value = selectedVariantId;
        }

        // Met à jour l'input du formulaire
        let formInputVariant = document.querySelector("form[action='/cart/add'] input[name='id']");
        if (formInputVariant) {
            formInputVariant.value = selectedVariantId;
            formInputVariant.dispatchEvent(new Event('change')); // Déclenche un événement de changement
        }

        // Met à jour le prix affiché avec mise en forme correcte
let productData = document.getElementById('product-data');
let productHandle = productData ? productData.getAttribute('data-product-handle') : null;

console.log("✔ Handle du produit récupéré :", productHandle);


if (!productHandle) {
    console.error("❌ Impossible de récupérer le handle du produit !");
    return;
}

console.log("🔍 Handle utilisé pour l'API Shopify :", productHandle);

fetch(`/products/${productHandle}.json`)
.then(response => response.json())
.then(data => {
    const variant = data.product.variants.find(v => v.id == selectedVariantId);
    if (variant) {
        console.log("🎯 Variante trouvée :", variant);

        let priceContainer = document.querySelector(".product-form__submit .prices-items-collection");
        let comparePrice = variant.compare_at_price / 100;
let price = variant.price / 100;


if (priceContainer) {
    if (comparePrice && comparePrice > price) {
        priceContainer.innerHTML = `
            <div style="display: flex; align-items: center; gap: 8px; margin-left: 5px">
                <div style="display: flex; align-items: center;">
                    <span class="price-item--regular">
                        <span class="promo">PROMO</span>
                        <span class="price-item-collection_atc;">
                            ${(comparePrice * 100).toFixed(2).replace(".", ",")}€
                        </span>
                    </span>
                </div>
                <span style="font-weight: bold; margin-left: 6px; font-size: 16px;">
                    ${(price * 100).toFixed(2).replace(".", ",")}€
                </span>
            </div>`;
    } else {
        priceContainer.innerHTML = `
            <div style="display: flex; align-items: center; gap: 8px; margin-left: 15px;">
                <span style="font-weight: bold; font-size: 16px;">
                    ${(price * 100).toFixed(2).replace(".", ",")}€
                </span>
            </div>`;
    }
} else {
    console.error("❌ Élément priceContainer non trouvé !");
}

    } else {
        console.error("❌ Variante non trouvée !");
    }
})
.catch(error => console.error("❌ Erreur lors de la récupération du prix :", error));

    });
});


      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        if (this.closest('cart-drawer')) {
          this.closest('cart-drawer').querySelector('.loading__overlay').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Forcer la mise à jour de l'ID de la variante sélectionnée
let selectedVariantId = document.getElementById("variant-id")?.value;
if (selectedVariantId) {
    let formInput = this.form.querySelector('[name=id]');
    if (formInput) {
        formInput.value = selectedVariantId;
    }
}


        const formData = new FormData(this.form);
        /* Track which button was used to add to cart */
        const isSticky = this.closest('.sticky-product-form, .product-sticky-form, [data-sticky-add-to-cart]');
        formData.append('properties[_source]', isSticky ? 'sticky-atc' : 'product-page');
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* Chain: check cart -> optionally add upsell -> add main product */
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig())
                .then((r) => r.json())
                .then((upsellResponse) => {
                  /* Track the silent upsell add so Shopify sees it */
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form-upsell',
                    productVariantId: this.upsellVariantId,
                    cartData: upsellResponse,
                  });
                });
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (this.closest('cart-drawer')) {
              this.closest('cart-drawer').querySelector('.loading__overlay').classList.add('hidden');
            }
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);
        upsellFormData.append('properties[_source]', 'upsell-auto');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }
 

      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      
      
    }
  );
}
